import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter } from 'react-router-dom';
import Environment from './Infrastructure/Environment';
import './index.css'
import App from './App';


// Polyfill to assure compatibility of PdfViewer with old browsers
if (!Promise.withResolvers) {
  Promise.withResolvers = function() {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}



const root = ReactDOM.createRoot(document.getElementById('root'));

process.env.REACT_APP_SET_ENV = Environment;
// console.log('------------- Environment ******** ---------------');
// console.log(Environment);
// console.log('----------------------------');



root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);


